var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8677 0.858398H8.00576C3.59137 0.858398 0 4.44976 0 8.86416V19.7261C0 24.1405 3.59137 27.7319 8.00576 27.7319H18.8677C23.2821 27.7319 26.8735 24.1405 26.8735 19.7261V8.86416C26.8734 4.44976 23.2821 0.858398 18.8677 0.858398ZM24.17 19.7261C24.17 22.6545 21.7961 25.0284 18.8677 25.0284H8.00576C5.07741 25.0284 2.70347 22.6545 2.70347 19.7261V8.86416C2.70347 5.93576 5.07741 3.56187 8.00576 3.56187H18.8677C21.7961 3.56187 24.17 5.93576 24.17 8.86416V19.7261Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4368 7.34473C9.60429 7.34473 6.48633 10.4627 6.48633 14.2951C6.48633 18.1276 9.60429 21.2456 13.4368 21.2456C17.2693 21.2456 20.3872 18.1276 20.3872 14.2951C20.3872 10.4626 17.2693 7.34473 13.4368 7.34473ZM13.4368 18.5421C11.0912 18.5421 9.1898 16.6407 9.1898 14.2952C9.1898 11.9496 11.0913 10.0482 13.4368 10.0482C15.7823 10.0482 17.6837 11.9496 17.6837 14.2952C17.6837 16.6407 15.7823 18.5421 13.4368 18.5421Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4005 9.06277C21.3203 9.06277 22.0659 8.31714 22.0659 7.39735C22.0659 6.47757 21.3203 5.73193 20.4005 5.73193C19.4807 5.73193 18.735 6.47757 18.735 7.39735C18.735 8.31714 19.4807 9.06277 20.4005 9.06277Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.3d2148d1f8dd78679ce2e73d5b20aa54.svg";
export { ForwardRef as ReactComponent };